import React, { useState } from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import RoleAssignForm from "./Components/RoleAssignForm";
import RoleAssignTable from "./Components/RoleAccessTable";
import { useRoleVerify } from "Common/RoleVerify";

const RoleAssign = () => {
  const [refresh, setRefresh] = useState(false);
  const canCreateAndEdit = useRoleVerify("", ["can_create", "can_delete"]);
  return (
    <PageBody
      card={false}
      headerchildren={
        canCreateAndEdit && (
          <HeadingOne>Role Assign</HeadingOne>
        )
      }
    >
      {/* Form Section */}
      {
        canCreateAndEdit && (
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <RoleAssignForm setRefresh={setRefresh} refresh={refresh} />
              </div>
            </div>
          </div>
        )
      }

      {/* Table Section */}
      <div className="col-12 mt-4">
        <HeadingOne>Role Assign List</HeadingOne>
      </div>

      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <RoleAssignTable refresh={refresh} />
          </div>
        </div>
      </div>
    </PageBody>
  );
};

export default RoleAssign;
